{
	"Spanish": {
		"Greetings": "Esto es lo que puede esperar de", 
		"releaseVersion": "Versión 25.4",
		"acknowledge": "Gracias",
		"General": "General", 
		"Messaging": "Mensajería", 
		"Gamification": "Gamificación", 
		"Coaching": "Entrenamiento", 
		"QA": "Control de Calidad", 
		"Dashboards": "Tableros", 
		"Wallboards": "Tableros de pared",
		"Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [
			], 
			"Coaching": [
			], 
			"QA": [], 
			"Dashboards": [
			], 
			"Wallboards": [
			]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
        "NiceInContactNotes": {
            "General": [],
            "Messaging": [],
            "Gamification": [],
            "Coaching": [
                {
                    "Description": "Fecha de Realización y Estado Guardar como Borrador:",
                    "Details": [
                        "El paquete de entrenamiento recibirá una nueva funcionalidad llamada \"Fecha de Realización\", que permitirá a los supervisores documentar correctamente una sesión de entrenamiento que ocurrió en el pasado pero que no fue registrada oportunamente.",
                        "También se incorporará el estado \"Guardar como borrador\" al paquete de entrenamiento. Los supervisores podrán seleccionarlo si desean continuar más tarde. Si una sesión de entrenamiento se guarda como borrador, los agentes no podrán verla y no se podrá seleccionar una fecha de realización."
                    ]
                }
            ],
            "QA": [],
            "Dashboards": [
                {
                    "Description": "Widget de Calibre: Edición de Valores Mínimos y Máximos. Se han introducido nuevas opciones de personalización para mejorar la usabilidad y flexibilidad del Widget de Calibre:",
                    "Details": [
                        "Ahora los usuarios pueden establecer manualmente los valores mínimo y máximo para la escala del calibre.",
                        "Los valores predeterminados se basan en los parámetros objetivo de la métrica, pero pueden ajustarse según sea necesario.",
                        "Los tableros compartidos mantienen y muestran la configuración del calibre para todos los visualizadores.",
                        "La nueva opción de Configuración de Min/Máx está disponible desde el menú de tres puntos del widget.",
                        "Un botón Restablecer a Predeterminado permite a los usuarios volver rápidamente a la configuración original."
                    ]
                },
                {
                    "Description": "Rangos de Fechas Personalizados en el Widget de Revisión de Métrica. Se ha mejorado el widget de Revisión de Métrica. Anteriormente, solo se podían seleccionar tres fechas fijas y no era posible personalizarlas. Ahora podrá seleccionar tres fechas diferentes para facilitar la comparación:",
                    "Details": [
                        "Esta funcionalidad estará disponible en la configuración del widget.",
                        "Solo las fechas pasadas y la fecha actual son elegibles.",
                        "Los rangos de fechas que incluyan fechas futuras se limitarán hasta hoy."
                    ]
                },
                {
                    "Description": "Estadísticas de Gamificación Convertidas en Métricas de Tablero. Se ha creado un nuevo conjunto de métricas para usar en los widgets de Tablero, provenientes de las Estadísticas de Gamificación:",
                    "Details": [
                        "Vea estadísticas en tiempo real de juegos activos, desafíos y órdenes.",
                        "Filtre por agente, equipo, compañía o grupos personalizados.",
                        "Ayuda a rastrear la participación, identificar tendencias y apoyar el entrenamiento.",
                        "Permite tomar decisiones basadas en datos para aumentar la motivación y los resultados.",
                        "Los widgets elegibles para mejor visibilidad son Resumen Expandido y Resumen.",
                        "Esta funcionalidad está disponible bajo solicitud de modificación."
                    ]
                }
            ],
            "Wallboards": []
        },
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"French": {
		"Greetings": "Voici à quoi s'attendre de", 
		"releaseVersion": "Version 25.4",
		"acknowledge": "Merci",
		"General": "Général", 
		"Messaging": "Messagerie", 
		"Gamification": "Ludification", 
		"Coaching": "Entraînement", 
		"QA": "AQ", 
		"Dashboards": "Tableaux de bord", 
		"Wallboards": "Panneaux Muraux",
		"Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [
			],
            "Coaching": [
            ], 
			"QA": [],
            "Dashboards": [
            ], 
			"Wallboards": [
			]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
        "NiceInContactNotes": {
            "General": [],
            "Messaging": [],
            "Gamification": [],
            "Coaching": [
                {
                    "Description": "Date de réalisation et statut « Enregistrer comme brouillon »:",
                    "Details": [
                        "Le module d’encadrement bénéficiera d’une nouvelle fonctionnalité appelée « Date de réalisation », permettant aux superviseurs de documenter une séance d’encadrement qui aurait eu lieu dans le passé mais n’aurait pas été enregistrée à temps.",
                        "Un statut « Enregistrer comme brouillon » sera également intégré au module d’encadrement. Les superviseurs pourront le sélectionner s’ils souhaitent continuer plus tard. Si une séance est enregistrée comme brouillon, les agents ne pourront pas la voir et une date de réalisation ne pourra pas être sélectionnée."
                    ]
                }
            ],
            "QA": [],
            "Dashboards": [
                {
                    "Description": "Widget Jauge : Édition des valeurs minimales et maximales. De nouvelles options de personnalisation ont été introduites pour améliorer l’utilisabilité et la flexibilité du Widget Jauge:",
                    "Details": [
                        "Les utilisateurs peuvent désormais définir manuellement les valeurs minimale et maximale pour l’échelle de la jauge.",
                        "Les valeurs par défaut sont basées sur les paramètres objectifs de la métrique, mais peuvent être ajustées selon les besoins.",
                        "Les tableaux de bord partagés conservent et affichent la configuration de la jauge pour tous les visualisateurs.",
                        "La nouvelle option de paramètres Min/Max est disponible depuis le menu à trois points du widget.",
                        "Un bouton « Réinitialiser par défaut » permet aux utilisateurs de revenir rapidement à la configuration d’origine."
                    ]
                },
                {
                    "Description": "Plages de dates personnalisées dans le widget d’examen de métrique. Une amélioration a été ajoutée au widget d’examen de métrique. Auparavant, il était possible de sélectionner trois dates fixes, sans personnalisation. Désormais, vous pouvez choisir trois dates différentes pour faciliter la comparaison:",
                    "Details": [
                        "Cette fonctionnalité est disponible dans les paramètres du widget.",
                        "Seules les dates passées et aujourd’hui sont éligibles.",
                        "Les plages de dates contenant des dates futures seront limitées jusqu’à aujourd’hui."
                    ]
                },
                {
                    "Description": "Statistiques de ludification converties en métriques de tableau de bord. Un nouvel ensemble de métriques issues des statistiques de ludification est désormais disponible pour les widgets de tableau de bord:",
                    "Details": [
                        "Visualisez les statistiques en temps réel des jeux actifs, défis et commandes.",
                        "Filtrez par agent, équipe, entreprise ou groupes personnalisés.",
                        "Permet de suivre l’engagement, repérer les tendances et soutenir l’encadrement.",
                        "Facilite la prise de décisions basée sur les données pour renforcer la motivation et les résultats.",
                        "Les widgets concernés pour une meilleure visibilité sont « Résumé développé » et « Résumé ».",
                        "Cette fonctionnalité est disponible sur demande de modification."
                    ]
                }
            ],
            "Wallboards": []
        },
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"German": {
		"Greetings": "Das erwartet Sie", 
		"releaseVersion": "Freigeben 25.4",
		"acknowledge": "Vielen Dank",
		"General": "Allgemein", 
		"Messaging": "Nachrichtenübermittlung", 
		"Gamification": "Gamifizierung", 
		"Coaching": "Coaching", 
		"QA": "QA", 
		"Dashboards": "Dashboards", 
		"Wallboards": "Wallboards",
		"Notes": 
			{
            "General": [
            ],
			"Messaging": [
				
			], 
			"Gamification": [
			],
            "Coaching": [
            ], 
			"QA": [],
            "Dashboards": [
            ], 
			"Wallboards": [
			]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
        "NiceInContactNotes": {
            "General": [],
            "Messaging": [],
            "Gamification": [],
            "Coaching": [
                {
                    "Description": "Durchführungsdatum und Status „Als Entwurf speichern“:",
                    "Details": [
                        "Das Coaching-Paket erhält eine neue Funktion namens „Durchführungsdatum“, mit der Vorgesetzte ein Coaching, das in der Vergangenheit stattgefunden hat, aber nicht dokumentiert wurde, nachträglich erfassen können.",
                        "Außerdem wird der Status „Als Entwurf speichern“ integriert. Vorgesetzte können diesen Status wählen, falls sie später fortfahren möchten. Wird ein Coaching als Entwurf gespeichert, ist es für die Agenten nicht sichtbar und ein Durchführungsdatum kann nicht ausgewählt werden."
                    ]
                }
            ],
            "QA": [],
            "Dashboards": [
                {
                    "Description": "Messgerät-Widget: Bearbeitung von Minimal- und Maximalwerten. Wir haben neue Anpassungsoptionen eingeführt, um die Benutzerfreundlichkeit und Flexibilität des Messgerät-Widgets zu verbessern:",
                    "Details": [
                        "Benutzer können jetzt manuell die Minimal- und Maximalwerte für die Skala des Messgeräts festlegen.",
                        "Standardwerte basieren auf den Zielparametern der Metrik, können aber bei Bedarf angepasst werden.",
                        "Geteilte Dashboards behalten die konfigurierten Einstellungen des Messgeräts und zeigen sie für alle Betrachter an.",
                        "Die neue Min/Max-Einstellungsoption ist über das Drei-Punkte-Menü des Widgets verfügbar.",
                        "Mit einer Schaltfläche „Auf Standard zurücksetzen“ können Benutzer schnell zu den ursprünglichen Einstellungen zurückkehren."
                    ]
                },
                {
                    "Description": "Benutzerdefinierte Datumsbereiche im Metrik-Review-Widget. Das Metrik-Review-Widget wurde erweitert. Bisher konnten nur drei feste Daten ausgewählt werden, eine individuelle Auswahl war nicht möglich. Jetzt können Sie drei verschiedene Daten für einen einfacheren Vergleich auswählen:",
                    "Details": [
                        "Diese Funktion ist in den Widget-Einstellungen verfügbar.",
                        "Nur vergangene Daten und das heutige Datum sind zulässig.",
                        "Datumsbereiche, die zukünftige Daten enthalten, werden bis heute begrenzt."
                    ]
                },
                {
                    "Description": "Gamification-Statistiken als Dashboard-Metriken. Ein neues Set von Metriken aus den Gamification-Statistiken steht jetzt für Dashboard-Widgets zur Verfügung:",
                    "Details": [
                        "Echtzeitstatistiken für aktive Spiele, Herausforderungen und Bestellungen anzeigen.",
                        "Nach Agent, Team, Unternehmen oder benutzerdefinierten Gruppen filtern.",
                        "Hilft, Engagement zu verfolgen, Trends zu erkennen und Coaching zu unterstützen.",
                        "Ermöglicht datenbasierte Entscheidungen zur Steigerung von Motivation und Ergebnissen.",
                        "Für bessere Sichtbarkeit sind die Widgets „Erweiterte Zusammenfassung“ und „Zusammenfassung“ geeignet.",
                        "Diese Funktion ist auf Anfrage verfügbar."
                    ]
                }
            ],
            "Wallboards": []
        },
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"CanadianFrench": {
		"Greetings": "Voici à quoi s'attendre de", 
		"releaseVersion": "Version 25.4",
		"acknowledge": "Merci",
		"General": "Général", 
		"Messaging": "Messagerie", 
		"Gamification": "Ludification", 
		"Coaching": "Entraînement", 
		"QA": "AQ", 
		"Dashboards": "Tableaux de bord", 
		"Wallboards": "Panneaux d’affichage",
		"Notes": 
			{
            "General": [
            ],
			"Messaging": [], 
			"Gamification": [
			],
            "Coaching": [
            ], 
			"QA": [],
            "Dashboards": [
            ],
            "Wallboards": [
            ]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
        "NiceInContactNotes": {
            "General": [],
            "Messaging": [],
            "Gamification": [],
            "Coaching": [
                {
                    "Description": "Date de réalisation et statut « Enregistrer comme brouillon »:",
                    "Details": [
                        "Le module de coaching recevra une nouvelle fonctionnalité appelée « Date de réalisation », permettant aux superviseurs de documenter une session de coaching qui aurait eu lieu dans le passé mais n’aurait pas été enregistrée à temps.",
                        "Un statut « Enregistrer comme brouillon » sera également intégré au module de coaching. Les superviseurs pourront le sélectionner s’ils souhaitent continuer plus tard. Si une session est enregistrée comme brouillon, les agents ne pourront pas la voir et une date de réalisation ne pourra pas être sélectionnée."
                    ]
                }
            ],
            "QA": [],
            "Dashboards": [
                {
                    "Description": "Widget Jauge : Édition des valeurs minimales et maximales. De nouvelles options de personnalisation ont été ajoutées pour améliorer l’utilisabilité et la flexibilité du widget Jauge:",
                    "Details": [
                        "Les utilisateurs peuvent maintenant définir manuellement les valeurs minimale et maximale pour l’échelle de la jauge.",
                        "Les valeurs par défaut sont basées sur les paramètres objectifs de la métrique, mais peuvent être ajustées selon les besoins.",
                        "Les tableaux de bord partagés conservent la configuration de la jauge et l’affichent pour tous les visualisateurs.",
                        "La nouvelle option de paramètres Min/Max est disponible depuis le menu à trois points du widget.",
                        "Un bouton « Réinitialiser par défaut » permet aux utilisateurs de revenir rapidement à la configuration d’origine."
                    ]
                },
                {
                    "Description": "Plages de dates personnalisées dans le widget d’examen de métrique. Une amélioration a été ajoutée au widget d’examen de métrique. Auparavant, il était possible de sélectionner trois dates fixes, sans personnalisation. Maintenant, vous pouvez choisir trois dates différentes pour faciliter la comparaison:",
                    "Details": [
                        "Cette fonctionnalité est disponible dans les paramètres du widget.",
                        "Seules les dates passées et aujourd’hui sont admissibles.",
                        "Les plages de dates contenant des dates futures seront limitées jusqu’à aujourd’hui."
                    ]
                },
                {
                    "Description": "Statistiques de gamification converties en métriques de tableau de bord. Un nouvel ensemble de métriques provenant des statistiques de gamification est maintenant disponible pour les widgets de tableau de bord:",
                    "Details": [
                        "Affichez les statistiques en temps réel des jeux actifs, défis et commandes.",
                        "Filtrez par agent, équipe, entreprise ou groupes personnalisés.",
                        "Permet de suivre l’engagement, repérer les tendances et soutenir le coaching.",
                        "Facilite la prise de décisions basée sur les données pour augmenter la motivation et les résultats.",
                        "Les widgets concernés pour une meilleure visibilité sont « Sommaire étendu » et « Sommaire ».",
                        "Cette fonctionnalité est disponible sur demande de modification."
                    ]
                }
            ],
            "Wallboards": []
        },
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"BrazilianPortuguese": {
		"Greetings": "Aqui está o que esperar de", 
		"releaseVersion": "Versión 25.4",
		"acknowledge": "Obrigado",
		"General": "Em geral", 
		"Messaging": "Messagerie", 
		"Gamification": "Gamificação", 
		"Coaching": "Entraînement", 
		"QA": "CQ", 
		"Dashboards": "Painéis", 
		"Wallboards": "Wallboards",
		"Notes": 
			{
            "General": [
            ],
			"Messaging": [],
            "Gamification": [
            ],
            "Coaching": [
            ], 
			"QA": [],
            "Dashboards": [
            ],
            "Wallboards": [
            ]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
        "NiceInContactNotes": {
            "General": [],
            "Messaging": [],
            "Gamification": [],
            "Coaching": [
                {
                    "Description": "Data de Realização e Status \"Salvar como Rascunho\":",
                    "Details": [
                        "O pacote de coaching receberá uma nova funcionalidade chamada \"Data de Realização\", permitindo que supervisores documentem uma sessão de coaching que ocorreu no passado, mas não foi registrada corretamente.",
                        "Também será incorporado o status \"Salvar como rascunho\" ao pacote de coaching. Os supervisores poderão selecioná-lo caso desejem continuar mais tarde. Se um coaching for salvo como rascunho, os agentes não poderão visualizá-lo e uma data de realização não poderá ser selecionada."
                    ]
                }
            ],
            "QA": [],
            "Dashboards": [
                {
                    "Description": "Widget Medidor: Edição de Valor Mínimo e Máximo. Novas opções de personalização foram introduzidas para melhorar a usabilidade e flexibilidade do Widget Medidor:",
                    "Details": [
                        "Os usuários agora podem definir manualmente os valores mínimo e máximo para a escala do medidor.",
                        "Os valores padrão são baseados nos parâmetros objetivos da métrica, mas podem ser ajustados conforme necessário.",
                        "Painéis compartilhados mantêm e exibem as configurações do medidor para todos os visualizadores.",
                        "A nova opção de Configuração Mín/Máx está disponível no menu de três pontos do widget.",
                        "Um botão \"Redefinir para padrão\" permite que os usuários revertam rapidamente para as configurações originais."
                    ]
                },
                {
                    "Description": "Intervalos de Datas Personalizados no Widget de Revisão de Métrica. Uma melhoria foi adicionada ao widget de revisão de métrica. Antes, era possível selecionar apenas três datas fixas, sem personalização. Agora, você pode escolher três datas diferentes para facilitar a comparação:",
                    "Details": [
                        "Esta funcionalidade está disponível nas configurações do widget.",
                        "Somente datas passadas e hoje são elegíveis.",
                        "Intervalos de datas que incluam datas futuras serão limitados até hoje."
                    ]
                },
                {
                    "Description": "Estatísticas de Gamificação Convertidas em Métricas de Painel. Um novo conjunto de métricas provenientes das estatísticas de gamificação está disponível para uso nos widgets de painel:",
                    "Details": [
                        "Visualize estatísticas em tempo real de jogos ativos, desafios e pedidos.",
                        "Filtre por agente, equipe, empresa ou grupos personalizados.",
                        "Ajuda a acompanhar o engajamento, identificar tendências e apoiar o coaching.",
                        "Permite decisões baseadas em dados para aumentar a motivação e os resultados.",
                        "Os widgets elegíveis para melhor visibilidade são \"Resumo Expandido\" e \"Resumo\"."
                    ]
                }
            ],
            "Wallboards": []
        },
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"Dutch": {
		"Greetings": "Hier leest u wat u ervan kunt verwachten", 
		"releaseVersion": "Uitgave 25.4",
		"acknowledge": "Bedankt",
		"General": "Algemeen", 
		"Messaging": "Messagerie", 
		"Gamification": "Gamificatie", 
		"Coaching": "Entraînement", 
		"QA": "QA", 
		"Dashboards": "Dashboards", 
		"Wallboards": "Wallboards",
		"Notes": 
			{
            "General": [
            ],
			"Messaging": [],
            "Gamification": [
            ],
            "Coaching": [
            ], 
			"QA": [],
            "Dashboards": [
            ],
            "Wallboards": [
            ]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
        "NiceInContactNotes": {
            "General": [],
            "Messaging": [],
            "Gamification": [],
            "Coaching": [
                {
                    "Description": "Datum uitgevoerd en Status \"Opslaan als concept\":",
                    "Details": [
                        "Het coachingpakket krijgt een nieuwe functionaliteit genaamd \"Datum uitgevoerd\", waarmee supervisors een coaching kunnen documenteren die in het verleden heeft plaatsgevonden maar niet correct is vastgelegd.",
                        "Ook wordt de status \"Opslaan als concept\" toegevoegd aan het coachingpakket. Supervisors kunnen deze selecteren als ze later willen doorgaan. Als een coaching als concept wordt opgeslagen, is deze niet zichtbaar voor agents en kan er geen uitvoerdatum worden geselecteerd."
                    ]
                }
            ],
            "QA": [],
            "Dashboards": [
                {
                    "Description": "Meter Widget: Bewerken van Minimum- en Maximumwaarden. Er zijn nieuwe personalisatie-opties geïntroduceerd om de bruikbaarheid en flexibiliteit van de Meter Widget te verbeteren:",
                    "Details": [
                        "Gebruikers kunnen nu handmatig de minimum- en maximumwaarden voor de schaal van de meter instellen.",
                        "Standaardwaarden zijn gebaseerd op de objectieve parameters van de metriek, maar kunnen indien nodig worden aangepast.",
                        "Gedeelde dashboards behouden en tonen de geconfigureerde meterinstellingen voor alle kijkers.",
                        "De nieuwe Min/Max-instellingen zijn beschikbaar via het 3-puntenmenu van de widget.",
                        "Met een knop \"Reset naar standaard\" kunnen gebruikers snel terugkeren naar de oorspronkelijke instellingen."
                    ]
                },
                {
                    "Description": "Aangepaste Datumbereiken in de Metriek Review Widget. Er is een verbetering toegevoegd aan de Metriek Review Widget. Voorheen konden er drie vaste datums worden geselecteerd, zonder mogelijkheid tot aanpassing. Nu kun je drie verschillende datums kiezen voor een eenvoudigere vergelijking:",
                    "Details": [
                        "Deze functionaliteit is beschikbaar in de widgetinstellingen.",
                        "Alleen eerdere datums en vandaag zijn hiervoor toegestaan.",
                        "Datumbereiken die toekomstige datums bevatten, worden beperkt tot vandaag."
                    ]
                },
                {
                    "Description": "Gamification Statistieken omgezet naar Dashboard Metrieken. Er is een nieuwe set metrieken gemaakt op basis van Gamification Statistieken, nu beschikbaar voor gebruik in dashboard-widgets:",
                    "Details": [
                        "Bekijk realtime statistieken van actieve games, uitdagingen en bestellingen.",
                        "Filter op agent, team, bedrijf of aangepaste groepen.",
                        "Helpt bij het volgen van betrokkenheid, het herkennen van trends en het ondersteunen van coaching.",
                        "Maakt datagestuurde beslissingen mogelijk om motivatie en resultaten te verbeteren.",
                        "Widgets die in aanmerking komen voor betere zichtbaarheid zijn \"Uitgebreide Samenvatting\" en \"Samenvatting\".",
                        "Deze functie is beschikbaar op aanvraag voor aanpassing."
                    ]
                }
            ],
            "Wallboards": []
        },
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"Japanese": {
		"Greetings": "期待できること", 
		"releaseVersion": "リリース 25.4",
		"acknowledge": "ありがとう",
		"General": "一般的な", 
		"Messaging": "Messagerie", 
		"Gamification": "ゲーミフィケーション", 
		"Coaching": "Entraînement", 
		"QA": "質疑応答", 
		"Dashboards": "ダッシュボード", 
		"Wallboards": "ウォールボード",
		"Notes": 
			{
            "General": [
            ],
			"Messaging": [],
            "Gamification": [
            ],
            "Coaching": [
            ], 
			"QA": [],
            "Dashboards": [
            ],
            "Wallboards": [
            ]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
        "NiceInContactNotes": {
            "General": [],
            "Messaging": [],
            "Gamification": [],
            "Coaching": [
                {
                    "Description": "実施日と「下書きとして保存」ステータス",
                    "Details": [
                        "コーチングパッケージに新しい機能「実施日」が追加されます。これにより、スーパーバイザーは過去に実施したが適切に記録されていなかったコーチングを正しく記録できるようになります。",
                        "また、「下書きとして保存」ステータスもコーチングパッケージに組み込まれます。スーパーバイザーは、後で続行したい場合にこのステータスを選択できます。コーチングが下書きとして保存された場合、エージェントはその内容を閲覧できず、実施日も選択できません。"
                    ]
                }
            ],
            "QA": [],
            "Dashboards": [
                {
                    "Description": "ゲージウィジェット：最小値・最大値の編集. ゲージウィジェットの使いやすさと柔軟性を向上させるため、新しいカスタマイズオプションが追加されました。",
                    "Details": [
                        "ユーザーはゲージのスケールに対して、最小値と最大値を手動で設定できるようになりました。",
                        "デフォルト値は指標の客観的なパラメーターに基づいていますが、必要に応じて調整できます。",
                        "共有ダッシュボードは、すべての閲覧者に対して設定されたゲージの構成を保持し表示します。",
                        "新しい最小/最大設定オプションは、ウィジェットの3点メニューから利用できます。",
                        "「デフォルトにリセット」ボタンで、ユーザーは元の設定にすばやく戻すことができます。"
                    ]
                },
                {
                    "Description": "メトリックレビューウィジェットのカスタム日付範囲. メトリックレビューウィジェットに機能強化が追加されました。これまで、メトリックレビューウィジェットでは3つの固定日付しか選択できず、任意の日付にカスタマイズすることはできませんでした。今後は3つの異なる日付を選択できるようになり、比較が容易になります。",
                    "Details": [
                        "ユーザーはウィジェット設定でこの機能が利用可能であることを確認できます。",
                        "これに該当する日付は過去の日付と今日のみです。",
                        "将来の日付を含む日付範囲は今日までに制限されます。"
                    ]
                },
                {
                    "Description": "ゲーミフィケーションの統計をダッシュボード指標に変換. ダッシュボードウィジェットで使用できる新しい指標セットが作成されました。これらの指標はGamification Statsから取得されます。",
                    "Details": [
                        "アクティブなゲーム、チャレンジ、注文のリアルタイム統計を表示します。",
                        "エージェント、チーム、会社、またはカスタムグループでフィルタリング",
                        "エンゲージメントの追跡、トレンドの把握、コーチングのサポートに役立ちます",
                        "データに基づいた意思決定を可能にし、モチベーションと成果を向上します",
                        "視認性を高めるのに適したウィジェットは、拡張サマリーとサマリーです。",
                        "この機能は変更リクエストに応じて利用可能になります。"
                    ]
                }
            ],
            "Wallboards": []
        },
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	}
}
